import styled from '@emotion/styled';

/** Card width that keeps the compact look from the original 3-up layout. */
const CARD_WIDTH = 249;
const GAP = 16;
/* Cap the grid so it never exceeds 5 columns; below that it packs
   as many fixed-width cards as fit (down to ~3 on narrower screens). */
const MAX_COLUMNS = 5;

const AvatarGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, ${CARD_WIDTH}px);
  justify-content: center;
  gap: ${GAP}px;
  max-width: ${MAX_COLUMNS * CARD_WIDTH + (MAX_COLUMNS - 1) * GAP}px;
  margin: 0 auto;
`;

export default AvatarGrid;
